import { collectionsTransformer } from 'apis/transformers/collections'
import { recipesTransformer } from 'apis/transformers/recipes'

import { actionTypes } from './actionTypes'

export function menuCollectionsReceive(collections) {
  return {
    type: actionTypes.MENU_COLLECTIONS_RECEIVE,
    collections,
  }
}

export function menuReceiveMenu(recipes) {
  return {
    type: actionTypes.RECIPES_RECEIVE,
    recipes,
  }
}

const basketCurrentMenuIdChange = ({ id, attributes }) => ({
  type: actionTypes.BASKET_CURRENT_MENU_ID_CHANGE,
  menuId: id,
  menuUuid: attributes.uuid,
})

const loadMenuCollectionsWithMenuService = async (dispatch, getState) => {
  const state = getState()
  const menuServiceData = state.menuService

  if (!menuServiceData || !menuServiceData.data || !menuServiceData.data.length) {
    return
  }

  const activeMenu = menuServiceData.data[0]
  const transformedCollections = collectionsTransformer(activeMenu, menuServiceData)
  const transformedRecipes = recipesTransformer(activeMenu, menuServiceData)

  dispatch(menuCollectionsReceive(transformedCollections))
  dispatch(menuReceiveMenu(transformedRecipes))
  dispatch(basketCurrentMenuIdChange(activeMenu))
}

const mapRecipesAvailabilityToStock = (recipesAvailability, isAdmin) =>
  recipesAvailability.reduce((recipes, { recipeId, portions }) => {
    const recipeAvailability = Object.entries(portions).reduce(
      (availability, [portion, { available }]) => ({
        ...availability,
        [portion]: available || isAdmin ? 1000 : 0,
      }),
      {},
    )

    return {
      ...recipes,
      [recipeId]: recipeAvailability,
    }
  }, {})

export { loadMenuCollectionsWithMenuService, mapRecipesAvailabilityToStock }
